<template>
    <div class="table-action-buttons">
        <i v-if="this.$can('update-organisations')" class="fa fa-clone fa-lg pointer" @click="duplicate" :title="uLang('app.duplicate_type', { type: lang('app.trajectory_project') })"></i>
        <i v-if="this.$can('update-organisations')" class="fa fa-edit fa-lg pointer" @click="edit" :title="uLang('app.edit_type', { type: lang('app.trajectory_project') })"></i>
        <i v-if="this.$can('delete-organisations')" class="fa fa-trash fa-lg pointer" @click="remove" :title="uLang('app.delete_type', { type: lang('app.trajectory_project') })"></i>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import {
        DestroyAlert,
        SuccessAlert,
        ErrorAlert,
        InternalServerErrorAlert
    } from '~/Swals'

    export default {
        name: 'actions',
        props: ['data', 'index'],

        computed: mapGetters({
            user: 'authUser'
        }),

        methods: {
            remove() {
                new DestroyAlert({ entity: this.lang('app.trajectory_project') }).show().then(async () => {
                    this.destroy()
                })
            },

            edit() {
                this.$router.push({ name: 'admin.trajectory_projects.edit', params: { id: this.data.id }})
            },

            async destroy() {
                await window.axios.delete('/api/admin/trajectory-projects/' + this.data.id).then((data) => {
                    new SuccessAlert({title: this.data.name, text: this.uLang('app.entity_removed', { entity: this.lang('app.trajectory_project') })}).show();
                    vue.$emit('reloadTable');
                }).catch((error) => {
                    if(error.response.status == 422) {
                        new ErrorAlert({ text: error.response.data.message }).show()
                        return
                    }

                    new InternalServerErrorAlert({ text: uLang('app.unknown_error') }).show()
                });
            },

            async duplicate() {
                let {data} = await window.axios.post(route('trajectory-projects.duplicate', { trajectory_project: this.data.id }));

                this.$router.push({ name: 'admin.trajectory_projects.edit', params: { id: data.id }});
            },
        }
    }
</script>

<style lang="scss">
</style>
